import { apiSlice } from "../";
import { getToken } from "shared/utils/getToken";

const formularioSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // postNewFormulario: builder.mutation<FormularioResponse, IFormularioBody>({
    //   query: (data) => ({
    //     url: "formulario/cadastro",
    //     method: "POST",
    //     headers: {
    //       // Authorization: `Bearer ${token}`,
    //     },
    //     body: data,
    //   }),
    // }),
    // uploadFile: builder.mutation<void, UploadFile>({
    //   query: (data) => ({
    //     url: `formulario/upload-print-config-pc/${data.idFormulario}`,
    //     method: "PUT",
    //     headers: {
    //       // Authorization: `Bearer ${token}`,
    //     },
    //     body: data.file,
    //   }),
    // }),
    // uploadComprovanteMatricula: builder.mutation<void, UploadFile>({
    //   query: (data) => ({
    //     url: `formulario/upload-comp-matricula/${data.idFormulario}`,
    //     method: "PUT",
    //     headers: {
    //       // Authorization: `Bearer ${token}`,
    //     },
    //     body: data.file,
    //   }),
    // }),
    // uploadCurriculo: builder.mutation<void, UploadFile>({
    //   query: (data) => ({
    //     url: `formulario/upload-curriculo/${data.idFormulario}`,
    //     method: "PUT",
    //     headers: {
    //       // Authorization: `Bearer ${token}`,
    //     },
    //     body: data.file,
    //   }),
    // }),
    getCurriculo: builder.mutation<string, number>({
      query: (idFormulario) => ({
        url: `formulario/recuperar-curriculo?idFormulario=${idFormulario}`,
        method: "GET",
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
        responseHandler: (response) => response.text(),
      }),
    }),
    getPrintPc: builder.mutation<string, number>({
      query: (idFormulario) => ({
        url: `formulario/recuperar-print-config-pc?idFormulario=${idFormulario}`,
        method: "GET",
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
        responseHandler: (response) => response.text(),
      }),
    }),
    getComprovanteMatricula: builder.mutation<string, number>({ 
      query: (idFormulario) => ({
        url: `formulario/recuperar-comp-matricula?idFormulario=${idFormulario}`,
        method: "GET",
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
        responseHandler: (response) => response.text(),
      }),
    }),
  }),

  overrideExisting: false,
});

export const {
  // usePostNewFormularioMutation,
  // useUploadCurriculoMutation,
  // useUploadFileMutation,
  // useUploadComprovanteMatriculaMutation,
  useGetCurriculoMutation,
  useGetPrintPcMutation,
  useGetComprovanteMatriculaMutation,
  // useUpdateFormMutation,
} = formularioSlice;
